import { useEffect } from 'react';

const useDropdownToggle = () => {
  useEffect(() => {
    // Function to handle dropdown toggle
    const handleDropdownToggle = (e) => {
      e.preventDefault();
      e.stopPropagation();
      
      const menuItem = e.currentTarget.closest('.nk-menu-item.has-sub');
      if (!menuItem) return;
      
      const subMenu = menuItem.querySelector('.nk-menu-sub');
      if (!subMenu) return;
      
      // Toggle the active class
      const isActive = menuItem.classList.contains('active');
      
      // Close all other dropdowns
      document.querySelectorAll('.nk-menu-item.has-sub.active').forEach(item => {
        if (item !== menuItem) {
          item.classList.remove('active');
          const otherSubMenu = item.querySelector('.nk-menu-sub');
          if (otherSubMenu) {
            otherSubMenu.style.display = 'none';
          }
        }
      });
      
      // Toggle current dropdown
      if (isActive) {
        menuItem.classList.remove('active');
        subMenu.style.display = 'none';
      } else {
        menuItem.classList.add('active');
        subMenu.style.display = 'block';
      }
    };

    // Add event listeners to all dropdown toggles
    const dropdownToggles = document.querySelectorAll('.nk-menu-toggle');
    dropdownToggles.forEach(toggle => {
      toggle.addEventListener('click', handleDropdownToggle);
    });

    // Cleanup function
    return () => {
      dropdownToggles.forEach(toggle => {
        toggle.removeEventListener('click', handleDropdownToggle);
      });
    };
  }, []);
};

export default useDropdownToggle;
